import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import { Col, Row, Button, Container } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

const no_op = () => { };
const ModalMedicineForm = ({ onUpdate = false, getListAccountingAccount = no_op, accountToUpdate = null, setOpenForm = no_op }) => {

    const [accountingAccountTypeList, setAccountingAccountTypeList] = useState([]);
    const [accountingAccountType, setAccountingAccountType] = useState(null);
    const [accountCode, setAccountCode] = useState(null);
    const [nameAccount, setNameAccount] = useState(null);
    const [financingType, setFinancingType] = useState(null)

    useEffect(() => {
        getTypeAccounting();
    }, []);

    useEffect(() => {
        if (onUpdate) {
            setAccountCode(accountToUpdate.codigo);
            setNameAccount(accountToUpdate.descripcion);
            setAccountingAccountType(accountToUpdate.id_caja_contable_tipo);
            setFinancingType(accountToUpdate.tipo_financiacion);
        }
    }, [accountToUpdate])


    const getTypeAccounting = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'cajas-contables/listar-caja-tipos', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Data');
            }
        }).then(response => {
            setAccountingAccountTypeList(response);
        }).catch(err => {
            console.error(err);
        });
    }

    const addAccountingAccount = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'cajas-contables/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                codigo: accountCode,
                descripcion: nameAccount,
                id_tipo_caja: accountingAccountType,
                tipo_financiacion: financingType
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.text();
            }
            else {
                throw new Error('Data');
            }
        }).then(response => {
            getListAccountingAccount();
            setAccountingAccountType();
            setAccountCode();
            setNameAccount();
            setOpenForm(false);
        }).catch(err => {
            console.error(err);
        });
    }

    //cajas-contables/actualizar
    const updateAccountingAccount = async (idLedgerAccountToUpdate) => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'cajas-contables/actualizar', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                codigo: accountCode,
                descripcion: nameAccount,
                id_tipo_caja: accountingAccountType,
                tipo_financiacion: financingType,
                id_caja_contable: idLedgerAccountToUpdate
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.text();
            }
            else {
                throw new Error('Data');
            }
        }).then(response => {
            getListAccountingAccount();
            setOpenForm(false);
            setAccountingAccountType();
            setAccountCode();
            setNameAccount();
        }).catch(err => {
            console.error(err);
        });
    }

    return (
        <div>
            <Container>
                <div>
                    <div className="card__title">
                        <h5 className="bold-text">Crear Caja</h5>
                    </div>
                    <Row className="row-form-custom">
                        <Col md={6}>
                            <TextField
                                label="Código de Cuenta"
                                value={accountCode}
                                onChange={(event) => {
                                    setAccountCode(event.target.value);
                                }}
                                className="medical-material-form__field"
                                InputLabelProps={{
                                    style: { color: '#646777' }, shrink: true
                                }}
                            />
                        </Col>
                        <Col md={6}>
                            <TextField
                                label="Nombre de Cuenta"
                                value={nameAccount}
                                onChange={(event) => {
                                    setNameAccount(event.target.value);
                                }}
                                className="medical-material-form__field"
                                InputLabelProps={{
                                    style: { color: '#646777' }, shrink: true
                                }}
                            />
                        </Col>
                    </Row>
                    <Row className="row-form-custom">
                        <Col md={6}>
                            <TextField
                                label="Tipo de Cuenta"
                                value={accountingAccountType}
                                onChange={(event) => {
                                    setAccountingAccountType(event.target.value);
                                }}
                                select
                                className="medical-material-form__field"
                                InputLabelProps={{
                                    style: { color: '#646777' }, shrink: true
                                }}
                            >
                                {accountingAccountTypeList.map((item, index) => {
                                    return (<MenuItem key={index} value={item.id_caja_contable_tipo}>
                                        {item.nombre}
                                    </MenuItem>)
                                })}
                            </TextField>
                        </Col>
                        <Col md={6}>
                            <TextField
                                label="Tipo Financiación"
                                value={financingType}
                                onChange={(event) => {
                                    setFinancingType(event.target.value);
                                }}
                                select
                                className="medical-material-form__field"
                                InputLabelProps={{
                                    style: { color: '#646777' }, shrink: true
                                }}
                            >
                                <MenuItem key={1} value={1}>Debito</MenuItem>
                                <MenuItem key={2} value={2}>Crédito</MenuItem>
                            </TextField>
                        </Col>
                    </Row>
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        disabled={false}
                        variant="contained"
                        className="btn btn-primary btn-sm text-white"
                        onClick={() => {
                            if (onUpdate) {
                                updateAccountingAccount(accountToUpdate.id_caja_contable);
                            } else {
                                addAccountingAccount();
                            }
                        }}
                    >
                        {onUpdate ? "Actualizar" : "Crear"}
                    </Button>
                </div>
            </Container>
        </div>
    );
};
export default ModalMedicineForm;
